import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function FloatingCTA() {
  const primary = COMPANY.phones[0];
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      <a
        data-testid="floating-whatsapp"
        href={`https://wa.me/91${primary}?text=${encodeURIComponent(
          "Hi Jashvi Energy, I'd like a rooftop solar quote."
        )}`}
        target="_blank"
        rel="noreferrer"
        className="group h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] flex items-center justify-center shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] transition-transform hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6 text-white" />
      </a>
      <a
        data-testid="floating-call"
        href={`tel:${primary}`}
        className="group h-14 w-14 rounded-full bg-gradient-to-br from-[#FFC857] to-[#F5A623] flex items-center justify-center shadow-[0_10px_30px_-10px_rgba(255,200,87,0.6)] transition-transform hover:scale-110"
        aria-label="Call Jashvi Energy"
      >
        <Phone className="h-6 w-6 text-[#050B14]" />
      </a>
    </div>
  );
}
